<template lang="pug">
  #pageDashboardMaintenance

    

    v-card.dashboardMaintenanceCard(outlined)
      v-icon(size="48" color="primary") mdi-tools
      h3.dashboardMaintenanceTitle Dashboard temporariamente indisponível
      p.dashboardMaintenanceText Estamos realizando uma manutenção para otimização desta área. As demais funcionalidades do SOS Plantão continuam disponíveis normalmente.
      p.dashboardMaintenanceText Em breve esta visão estará disponível novamente.

</template>

<script>
// Estado estático de manutenção da Visão Geral — não importa o Dashboard
// (index.vue/mixins), então nenhuma leitura, endpoint ou polling é iniciado.
export default {
  name: 'ManagerDashboardMaintenance',
}
</script>

<style scoped lang="scss">
#pageDashboardMaintenance {
  .dashboardMaintenanceCard {
    max-width: 640px;
    margin: 24px auto 0;
    padding: 40px 32px;
    text-align: center;
  }

  .dashboardMaintenanceTitle {
    margin: 16px 0 12px;
    font-size: 18px;
    font-weight: 600;
  }

  .dashboardMaintenanceText {
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
